module.exports = __webpack_public_path__ + "static/media/plivo_authid_token.cb7dd6d6.jpg";